import { Routes, Route, useLocation } from "react-router-dom";
import { useContext, useLayoutEffect } from "react";
import { AuthContext } from "./context/auth-context";
import BookingsPage from "./components/bookings-page/Index";
import Layout from "./components/layout/Layout";
import NotFound from "./components/404";
import CustomersPage from "./components/customers-page/Index";
import VehiclesPage from "./components/vehicles-page/Index";
import GeneralPage from "./components/general-page/Index";
import Expenses from "./components/expenses-page/index";
import LoginPage from "./components/LoginPage";
import CustomerInfo from "./components/customers-page/CustomerInfo";
import VehicleInfo from "./components/vehicles-page/VehicleInfo";
import BookingInfo from "./components/bookings-page/BookingInfo";
import AddVehicle from "./components/vehicles-page/AddVehicle";
import AddBooking from "./components/bookings-page/AddBooking";
import PaymentsPage from "./components/payments-page/Index";
import PaymentInfo from "./components/payments-page/PaymentInfo";
import Tolls from "./components/tolls-page/index";
import Charging from "./components/charging-page/Index";
import BookingCharging from "./components/charging-page/BookingCharging";
import LoadingSpinnerWrapper from "./components/UI/LoadingSpinnerWrapper";
import Partners from "./components/partner-page/Partners";
import PartnerInfo from "./components/partner-page/PartnerInfo";
import Makes from "./components/vehicles-page/Makes";
import CouponsPage from "./components/coupons-page/Index";
import Locations from "./components/locations-page";
import LocationInfo from "./components/locations-page/LocationInfo";
import Employees from "./components/employees-page/Index";
import CustomerPayments from "./components/customers-page/CustomerPayments";
import PartnerReports from "./components/partner-page/PartnerReports";
import Query from "./components/query-page";
import Support from "./components/support-page";
import Maintenance from "./components/maintenance-page";
import MaintenanceInfo from "./components/maintenance-page/MaintenanceInfo";
import Billing from "./components/billing-page";
import Audits from "./components/audit-page";
import DownloadData from "./components/general-page/DownloadData";
import Service from "./components/service-page";
import Claims from "./components/claims-page";
import AddClaim from "./components/claims-page/AddClaim";
import ClaimInfo from "./components/claims-page/ClaimInfo";
import Applications from "./components/applications-page/Applications";
import ApplicationInfo from "./components/applications-page/ApplicationInfo";
import Quotes from "./components/quotes-page/Quotes";
import AddQuote from "./components/quotes-page/AddQuote";
import EmployeeInfo from "./components/employees-page/EmployeeInfo";
import Opportunities from "./components/customers-page/Opportunities";
import OpportunityInfo from "./components/customers-page/OpportunityInfo";
import OpportunitiesReport from "./components/customers-page/OpportunitiesReport";
import PaymentsReport from "./components/payments-page/PaymentsReport";
import ExpenseInfo from "./components/expenses-page/ExpenseInfo";
import Calendar from "./components/calendar-page";
import AddPartner from "./components/partner-page/AddPartner";
import RegisterVehicle from "./components/vehicles-page/RegisterVehicle";
import EmployeePermissions from "./components/employees-page/EmployeePermissions";
import Repossessions from "./components/repossessions-page/Repossessions";
import AddRepossession from "./components/repossessions-page/AddRepossession";
import RepossessionInfo from "./components/repossessions-page/RepossessionInfo";
import Announcements from "./components/announcements-page/Announcements";
import AddAnnouncement from "./components/announcements-page/AddAnnouncement";
import AnnouncementInfo from "./components/announcements-page/AnnouncementInfo";
import Disputes from "./components/disputes-page/Disputes";
import DisputeInfo from "./components/disputes-page/DisputeInfo";
import PricingPage from "./components/vehicles-page/PricingPage";
import Transactions from "./components/expenses-page/Transactions";
import TransactionInfo from "./components/expenses-page/TransactionInfo";

function App() {
  const { user, loadingUser } = useContext(AuthContext);
  const location = useLocation();

  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0, { behavior: "smooth" });
  }, [location.pathname]);

  if (loadingUser)
    return (
      <div className="flex items-center justify-center w-full h-screen bg-stone-900">
        <LoadingSpinnerWrapper />
      </div>
    );
  else if (user)
    return (
      <Layout>
        <Routes>
          <Route path="/" element={<GeneralPage />} />
          <Route path="/general" element={<GeneralPage />} />

          <Route path="/bookings" element={<BookingsPage />} />
          <Route path="/bookings/info" element={<BookingInfo />} />
          <Route path="/bookings/add" element={<AddBooking />} />

          <Route path="/customers" element={<CustomersPage />} />
          <Route path="/customers/info" element={<CustomerInfo />} />
          <Route path="/customers/payments" element={<CustomerPayments />} />
          <Route path="/opportunities" element={<Opportunities />} />
          <Route path="/opportunities/info" element={<OpportunityInfo />} />
          <Route
            path="/opportunities/report"
            element={<OpportunitiesReport />}
          />

          <Route path="/partners" element={<Partners />} />
          <Route path="/partners/info" element={<PartnerInfo />} />
          <Route path="/partners/report" element={<PartnerReports />} />
          <Route path="/partners/add" element={<AddPartner />} />

          <Route path="/applications" element={<Applications />} />
          <Route path="/applications/info" element={<ApplicationInfo />} />

          <Route path="/vehicles" element={<VehiclesPage />} />
          <Route path="/vehicles/info" element={<VehicleInfo />} />
          <Route path="/vehicles/add" element={<AddVehicle />} />
          <Route path="/vehicles/register" element={<RegisterVehicle />} />
          <Route path="/vehicles/pricing" element={<PricingPage />} />

          <Route path="/brands" element={<Makes />} />

          <Route path="/payments" element={<PaymentsPage />} />
          <Route path="/payments/info" element={<PaymentInfo />} />
          <Route path="/payments/report" element={<PaymentsReport />} />

          <Route path="/coupons" element={<CouponsPage />} />

          <Route path="/tolls" element={<Tolls />} />

          <Route path="/charging" element={<Charging />} />
          <Route path="/charging/booking" element={<BookingCharging />} />

          <Route path="/expenses" element={<Expenses />} />
          <Route path="/expenses/info" element={<ExpenseInfo />} />

          <Route path="/transactions" element={<Transactions />} />
          <Route path="/transactions/info" element={<TransactionInfo />} />

          <Route path="/locations" element={<Locations />} />
          <Route path="/locations/info" element={<LocationInfo />} />

          <Route path="/employees" element={<Employees />} />
          <Route path="/employees/info" element={<EmployeeInfo />} />
          <Route
            path="/employees/permissions"
            element={<EmployeePermissions />}
          />

          <Route path="/support" element={<Support />} />
          <Route path="/billing" element={<Billing />} />
          <Route path="/audits" element={<Audits />} />
          <Route path="/download" element={<DownloadData />} />
          <Route path="/query" element={<Query />} />
          <Route path="/calendar" element={<Calendar />} />

          <Route path="/claims" element={<Claims />} />
          <Route path="/claims/add" element={<AddClaim />} />
          <Route path="/claims/info" element={<ClaimInfo />} />

          <Route path="/maintenance" element={<Maintenance />} />
          <Route path="/maintenance/info" element={<MaintenanceInfo />} />
          <Route path="/service" element={<Service />} />

          <Route path="/quotes" element={<Quotes />} />
          <Route path="/quotes/add" element={<AddQuote />} />

          <Route path="/repossessions" element={<Repossessions />} />
          <Route path="/repossessions/add" element={<AddRepossession />} />
          <Route path="/repossessions/info" element={<RepossessionInfo />} />

          <Route path="/announcements" element={<Announcements />} />
          <Route path="/announcements/add" element={<AddAnnouncement />} />
          <Route path="/announcements/info" element={<AnnouncementInfo />} />

          <Route path="/disputes" element={<Disputes />} />
          <Route path="/disputes/info" element={<DisputeInfo />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
    );
  else return <LoginPage />;
}

export default App;
